import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PainelinsumoService } from '../../../../services/painelinsumo.service';
import { ToastService } from '../../../../services/toast.service';
import { DepositoInsumo } from '../../../../types/DepositoInsumo.type';
import { DepositoInsumoPosicao } from '../../../../types/DepositoInsumoPosicao.type';

@Component({
  selector: 'app-deposiform',
  templateUrl: './deposiform.component.html',
  styleUrl: './deposiform.component.css'
})
export class DeposiformComponent implements OnInit{

  deposito: DepositoInsumo = {} as DepositoInsumo

  posicaoClones:  { [s: string]: DepositoInsumoPosicao } = {};

  abreNovoPosicao: boolean = false

  constructor(private painelService: PainelinsumoService, private toastService: ToastService, private activatedRoute: ActivatedRoute){}

  ngOnInit(){
    this.buscaDeposito()
  }


  buscaDeposito(){
    let id = this.activatedRoute.snapshot.paramMap.get('id');

    if(id){
      this.painelService.getDeposito(id).subscribe({
        next: (data) => {
          this.deposito = data
        },
        error: (error) => {
          console.error(error)
          this.toastService.erro("Erro", error.error.message)
        }
      })
    }
  }

  editarPosicao(posicao: DepositoInsumoPosicao){
    this.posicaoClones[posicao.id as string] = {...posicao}
  }

  atualizarPosicao(posicao: DepositoInsumoPosicao, id: number){
    this.painelService.putPosicao(posicao).subscribe({
      next: (data) => {
        this.toastService.sucesso("Atualizado", "Posição atualizada")
      },
      error: (error) => {
        this.cancelarPosicao(posicao, id)
        this.toastService.erro("Erro", error.error.message)
      }
    })
  }

  cancelarPosicao(posicao: DepositoInsumoPosicao, id: number) {
    this.deposito.posicoes[id] = this.posicaoClones[posicao.id as string];
    delete this.posicaoClones[posicao.id as string];
  }

  abreNovoDialog() {
    this.abreNovoPosicao = true;
  }

  escondeNovoDialog() {
    this.abreNovoPosicao = false;

    this.buscaDeposito()
  }

}
